import * as PIXI from "pixi.js";
import { UIFonts, UIColors, UIPositioning } from "../Settings/UITheme.js";
import { MetadataTimelineEvent } from "./MetadataTimelineEvent.js";
export class BarHeader extends PIXI.Container {
    constructor(timeline) {
        super();
        this._headerText = new PIXI.Text("", UIFonts.trackFont);
        this._headerText.x = 15;
        this._headerText.y = 11;
        this._headerGraphics = new PIXI.Graphics();
        this._metadataTimelineEvent = new MetadataTimelineEvent(timeline);
        this.addChild(this._headerGraphics, this._headerText, this._metadataTimelineEvent);
    }
    initialise(x, width, barNumber, metadataEventPosition, metadataEventActive) {
        this.setX(x);
        this._headerGraphics.clear();
        this._headerGraphics.beginFill(UIColors.bgColor)
            .drawRect(1, 0, width, UIPositioning.timelineHeaderHeight)
            .endFill()
            .beginFill(UIColors.fgColor)
            .drawRect(1, 0, 2, UIPositioning.timelineHeaderHeight)
            .drawRect(1, UIPositioning.timelineHeaderHeight, width, 2)
            .endFill();
        this._headerText.text = (barNumber + 1).toString();
        this._metadataTimelineEvent.initialise(metadataEventPosition, metadataEventActive);
        return this;
    }
    setX(value) {
        this.x = value;
    }
    setVisible(value) {
        this.visible = value;
        this._metadataTimelineEvent.setVisible(value);
    }
}
//# sourceMappingURL=ScrollableBarHeader.js.map